import React, {  useEffect, useState } from 'react';
import Button, { ButtonGroup } from '@atlaskit/button';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";

import { closeModal } from "api/actions";

import {
    CLOSE_MODAL,
    SHOW_MODAL
} from 'constants/ActionTypes';

import MODAL_KEYS from 'components/Modals/keys';

const appearances = ['warning', 'danger'];

const processDeletion = () => {}

const MoveFiles = ({ closeModal, id, info = {}, showModal }) => {
    const [isOpen, setIsOpen] = useState(false);

    const close = () => {
        setIsOpen(false)
        closeModal({
            modalKey: '',
            closeModalKey: MODAL_KEYS.MOVE_FILES
        });
    }
  
    const open = (id) => {
        setIsOpen(true)
    }
  
    useEffect(() => {
        if (showModal && !isOpen && id) {
              // Only open the modal if all the necessary fields are available
            open(id)
        }
    }, [showModal])
  
    const actions = [
        { text: 'Yes', onClick: processDeletion },
        { text: 'Close', onClick: () => setIsOpen(false) },
    ];
  
    return (
        <div>
          <ModalTransition>
            {isOpen &&
                <Modal
                    key="active-modal"
                    actions={actions}
                    onClose={close}
                    heading={'Move Files'}
                >
                    
                </Modal>
            }
          </ModalTransition>
        </div>
      );
}

const dispatchToProps = (dispatch) => {
    return bindActionCreators({ closeModal }, dispatch)
};

const mapStateToProps = (state, ownProps) => {
    const newState = {
        id: state.modalId,
        type: state.type
    };

    switch(state.type) {
        case SHOW_MODAL:
            const infoKeys = state.modalInfo ? Object.keys(state.modalInfo) : [];

            console.log('TYPES', newState, infoKeys)

            if (state.modalKey === MODAL_KEYS.MOVE_FILES && infoKeys.length > 0) {
                newState.showModal = true
                newState.info = state.modalInfo;
                newState.modalKey = state.modalKey;
            }
            break;
        case CLOSE_MODAL:
            if (state.closeModalKey === MODAL_KEYS.MOVE_FILES) {
                newState.showModal = false;
            }
            break;
    }

    return newState;
}

export default connect(mapStateToProps, dispatchToProps)(MoveFiles);